import React, { useState, useEffect } from 'react';
import { connect } from 'formik';
import { connect as connectRedux } from 'react-redux';
import { FormikInput } from '../../../../web.common';
import ReactSelect from 'react-select';

const SchemeSelectorInternal = ({ category, schemes, content, onSchemeChange }) => {
  const [mappedSchemes, setMappedSchemes] = useState([]);

  useEffect(() => {
    if (category) {
      const filteredSchemes = schemes.filter(x => x.Category === category)
        .map(({ Name }) => ({ label: Name, value: Name }));
      setMappedSchemes(filteredSchemes);
    }
  }, [category, schemes]);

  const handleSchemeChange = (selectedOption) => {
    if (onSchemeChange) {
      onSchemeChange(selectedOption.value);
    }
  };

  return (
    <>
      {category ? (
        <ReactSelect
          key={`for-category-${category}`}
          name='SchemeName'
          value={mappedSchemes.filter(
            (x) => x.label == content.SchemeName
          )}
          type='select'
          description='Select product category'
          options={mappedSchemes}
          onChange={handleSchemeChange}
          workaroundSelectInitialValueCheck
          required
        />
      ) : null}
    </>
  );
};

export const SchemeSelectorHook = connect(connectRedux(({ schemes }) => ({ schemes }), {})(SchemeSelectorInternal));
